import React from "react";
import shiftsIcon from "../assets/shiftIcon.png"; 
import hoursIcon from "../assets/hoursIcon.png"; 
import earningsIcon from "../assets/earningsIcon.png"; 

const AttendanceCard = ({ 
  userStats, 
  setShowPaymentSummaryModal,
}) => {
  // Use totalEarnings from API if available, otherwise fallback to totalPaymentEarned or 0
  const totalEarnings = userStats?.totalEarnings !== undefined && userStats?.totalEarnings !== null 
    ? userStats.totalEarnings 
    : (userStats?.totalPaymentEarned || 0);

  return (
    <div className="grid grid-cols-3 gap-0">
      
      {/* Total Shifts */}
      <div
        onClick={() => setShowPaymentSummaryModal(true)}
        className="flex flex-col items-center text-center cursor-pointer hover:bg-gray-50 rounded-xl px-1 py-2 transition-all duration-200"
      >
        <div className="w-8 h-8 flex items-center justify-center mb-2">
          <img 
            src={shiftsIcon} 
            alt="Total Shifts" 
            className="w-8 h-8 object-contain"
          />
        </div>
        <p className="text-[10px] text-gray-500 leading-tight mb-1">Total Shifts</p>
        <p className="text-base font-bold text-gray-900 leading-tight">{userStats.totalShifts}</p>
      </div>

      {/* Shifts Hours */}
      <div
        onClick={() => setShowPaymentSummaryModal(true)}
        className="flex flex-col items-center text-center cursor-pointer hover:bg-gray-50 rounded-xl px-1 py-2 transition-all duration-200"
      >
        <div className="w-8 h-8 flex items-center justify-center mb-2">
          <img 
            src={hoursIcon} 
            alt="Shifts Hours" 
            className="w-8 h-8 object-contain"
          />
        </div>
        <p className="text-[10px] text-gray-500 leading-tight mb-1">Shifts Hours</p>
        <p className="text-base font-bold text-gray-900 leading-tight">{userStats.totalWorkingHours.toFixed(2)}</p>
      </div>

      {/* Total Earnings */}
      <div
        onClick={() => setShowPaymentSummaryModal(true)}
        className="flex flex-col items-center text-center cursor-pointer hover:bg-gray-50 rounded-xl px-1 py-2 transition-all duration-200"
      >
        <div className="w-8 h-8 flex items-center justify-center mb-2">
          <img 
            src={earningsIcon} 
            alt="Total Earnings" 
            className="w-8 h-8 object-contain"
          />
        </div>
        <p className="text-[10px] text-gray-500 leading-tight mb-1">Total Earnings</p>
        <p className="text-base font-bold text-gray-900 leading-tight">₹{totalEarnings}</p>
      </div>

    </div>
  );
};

export default AttendanceCard;